import { useStore } from '../store/store';
import { useMemo } from 'react';

const useAppWrapClass = () => {
  const { authStore, utilsStore } = useStore();
  const className = useMemo(() => {
    const classes = ['app-wrapper'];

    if (utilsStore.force100Height) {
      classes.push('force100height');
    }

    if (authStore.user) {
      classes.push('user-authorized');
    } else {
      classes.push('user-unknown');
    }

    return classes.join(' ');
  }, [authStore.user, utilsStore.force100Height]);

  return className;
};

export default useAppWrapClass;
